import React from 'react';

import { observer } from 'mobx-react';
import { IntlProvider, ReactIntlErrorCode } from 'react-intl';

import localeStore from 'src/stores/LocaleStore';

const defaultOnError = (err: { code: string }) => {
  if (err.code === ReactIntlErrorCode.MISSING_TRANSLATION) return;
  console.error(err);
};

export const IntlMobxProvider = observer((props: any) => (
  <IntlProvider
    {...props}
    onError={props.onError ?? defaultOnError}
    key={localeStore.currentLocale}
    locale={localeStore.currentLocale}
    messages={localeStore.currentMessages}
  />
));
